import Script from "next/script"
import React from "react"

type Props = {
  videoLink: string
  videoId: string
}

export const TikTokVideo: React.FC<Props> = ({ videoLink, videoId }) => {
  return (
    <>
      <blockquote
        className="tiktok-embed"
        cite={videoLink}
        data-video-id={videoId}
        style={{ maxWidth: "605px", minWidth: "325px" }}
      >
        <section />
      </blockquote>
      <Script src="https://www.tiktok.com/embed.js" type="text/javascript" />
    </>
  )
}
